import React from 'react';
import Logo from '../../assets/images/header/logo.png';
import './styles.scss';

export default function Loading() {
	return (
		<div className='loader'>
			<img src={Logo} alt='logo' />
		</div>
	);
}
